export enum QuoteSource_Enum{
    QuickQuote = 0,
    StockFeed
}